import { FC } from 'react'

import Button from '@/components/Button'

import classes from './StatusCard.module.css'
import { IStatusCardProps } from './types'

export const StatusCard: FC<IStatusCardProps> = ({
  title,
  description,
  buttonText,
  onButtonClick,
  isButtonDisabled = false,
}) => (
  <div className={classes.container}>
    <div className={classes.textSection}>
      <div className={classes.titleWrapper}>
        <span className={classes.title}>{title}</span>
      </div>
      <div className={classes.descriptionBox}>
        <p className={classes.description}>{description}</p>
      </div>
    </div>

    <div className={classes.buttonSection}>
      <Button
        variant="primaryGreen"
        className={classes.button}
        isDisabled={isButtonDisabled}
        onClick={onButtonClick}
      >
        {buttonText}
      </Button>
    </div>
  </div>
)
